import { secured } from '@/plugins/axios';

const resource = '/uuids/admin';

export default {
    uuidList: params => secured.get(`${resource}/uuids/`, { params }),
    activityLogList: params => secured.get(`${resource}/activity-logs/`, { params }),
    activitySummary: params => secured.get(`${resource}/activity-summary/`, { params }),
};
